/** Tool icons. Hand-drawn feel, always paired with a word label. */
const S = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };

export const IconFill = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M4.5 12.5 11 6l6.5 6.5L11 19z" />
    <path d="M8 9 6 4" />
    <path d="M19.5 15.5c1 1.4 1.5 2.3 1.5 3a1.5 1.5 0 0 1-3 0c0-.7.5-1.6 1.5-3Z" fill="currentColor" stroke="none" />
  </svg>
);

export const IconBrush = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M14.5 3.5 20.5 9.5 11 19H5v-6z" />
    <path d="M12.5 5.5 18.5 11.5" />
  </svg>
);

export const IconErase = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M8 20 3.5 15.5a2 2 0 0 1 0-2.8L12.7 3.5a2 2 0 0 1 2.8 0l5 5a2 2 0 0 1 0 2.8L13 19" />
    <path d="M8 20h12" />
    <path d="M9 8.5 15.5 15" />
  </svg>
);

export const IconUndo = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M4 9h11a5 5 0 0 1 0 10h-4" />
    <path d="M8 5 4 9l4 4" />
  </svg>
);

export const IconRedo = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M20 9H9a5 5 0 0 0 0 10h4" />
    <path d="M16 5l4 4-4 4" />
  </svg>
);

export const IconCheck = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="m5 13 4.5 4.5L19 7" />
  </svg>
);

export const IconBack = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M15 5 8 12l7 7" />
  </svg>
);

export const IconArrow = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M5 12h14" />
    <path d="m13 6 6 6-6 6" />
  </svg>
);

export const IconPlay = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M7 4.5 19 12 7 19.5z" fill="currentColor" />
  </svg>
);

export const IconSpeaker = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M4 9.5h3.5L12 5v14l-4.5-4.5H4z" />
    <path d="M16 9a4 4 0 0 1 0 6" />
    <path d="M18.5 6.5a7.5 7.5 0 0 1 0 11" />
  </svg>
);

export const IconBook = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M4 5.5A2 2 0 0 1 6 4h5v16H6a2 2 0 0 0-2 1.5z" />
    <path d="M20 5.5A2 2 0 0 0 18 4h-5v16h5a2 2 0 0 1 2 1.5z" />
  </svg>
);

export const IconHome = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M4 11 12 4l8 7" />
    <path d="M6 10v9h12v-9" />
    <path d="M10 19v-5h4v5" />
  </svg>
);

export const IconPalette = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <path d="M12 3a9 9 0 1 0 0 18c1.4 0 2-.9 2-1.8 0-1.2-1-1.6-1-2.7 0-.8.7-1.5 1.6-1.5H16a5 5 0 0 0 5-5c0-3.9-4-7-9-7Z" />
    <circle cx="8" cy="10.5" r="1.2" fill="currentColor" stroke="none" />
    <circle cx="12" cy="7.5" r="1.2" fill="currentColor" stroke="none" />
    <circle cx="16" cy="10" r="1.2" fill="currentColor" stroke="none" />
  </svg>
);

export const IconLock = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <rect x="4.5" y="10" width="15" height="10" rx="2.5" />
    <path d="M8 10V7.5a4 4 0 0 1 8 0V10" />
  </svg>
);

export const IconGrid = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <rect x="4" y="4" width="7" height="7" rx="2" />
    <rect x="13" y="4" width="7" height="7" rx="2" />
    <rect x="4" y="13" width="7" height="7" rx="2" />
    <rect x="13" y="13" width="7" height="7" rx="2" />
  </svg>
);

/** A strip of film — the reveal video export. */
export const IconFilm = (p: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...S} {...p}>
    <rect x="2.5" y="5" width="19" height="14" rx="2.5" />
    <path d="M7 5v14M17 5v14" />
    <path d="M2.5 12h19" />
  </svg>
);
